<template>
  <div class="profile-module">
    <!--<transition tag="div" name="fade">-->
      <div v-if="modalOpened" class="madalbackground" @click="closeModals"></div>
    <!--</transition>-->
    <!--edit profile and new user forced-->

    <div class="container">
      <transition tag="div" name="fade">
        <div class="mandatory-modal p-3" v-if="new_user || editUserModal">
        <div class="title">
          <p v-if="new_user">خوش آمدید</p>
          <p v-else>ویرایش پروفایل</p>
        </div>
        <div class="desc">
          <p v-if="new_user">
            خیلی خوشحالیم از پیوستن شما به کیشوتو. لطفا قبلا از شروع کار اطلاعات زیر را تکمیل کنید.
          </p>
        <!--  <p v-else>لطفا مقادیر نام و نام خانوادگی را دقیق و کامل وارد نمایید.</p>-->
        </div>
        <div class="input-container">
          <div class="container">

            <kish-input
                label="نام شما"
                :value="name"
                v-model="name"
                class="input-item"
                help="لطفا با رعایت موارد اخلاقی نام کامل خود را وارد کنید"
            />

           <!-- <kish-input
              label="نام خانوادگی"
              :value="last_name"
              v-model="last_name"
              class="input-item"
              help="نام و نام خانوادگی شما محرمانه ذخیره میشود"
            />-->


            <kish-input
              v-if="new_user"
              label="کد معرف"
              :value="otherxcode"
              v-model="otherxcode"
              class="input-item"
              help="در صورتی که از طرف شخصی به کیشوتو دعوت شده اید کد معرف را اینجا وارد کنید"
            />

            <kish-input
                v-else
                label="شماره کارت"
                :value="cardcode"
                v-model="cardcode"
                class="input-item"
                help="شماره کارت 16 رقمی خود را اینجا وارد کنید"
            />

          </div>
        </div>
        <button class="btn save-data mt-2" @click="updateProfile">
          ذخیره تغییرات
        </button>
        <button v-if="new_user === false" class="btn btn-outline-danger mt-2 w-100" @click="closeEditUserModal">
          بستن
        </button>
      </div>
      </transition>
    </div>


    <!--support modal-->

    <div class="container">
        <transition tag="div" name="fade">
          <div class="mandatory-modal support-modal pt-1 pb-1" v-if="supportModal">
        <div class="title">
          <p>پشتیبانی</p>
        </div>
        <div class="desc pre-formatted">
          <p v-html="supportText"></p>
        </div>
        <button class="btn btn-outline-danger mb-3 mx-auto d-flex justify-content-center mr-2 mb-2 w-80" @click="closeSupportModal">
          بستن
        </button>
      </div>
        </transition>
    </div>


    <!--rules modal-->

    <div class="container">
      <transition tag="div" name="fade">
        <div class="mandatory-modal pt-1 pb-1" v-if="rulesModal">
        <div class="title">
          <p>قوانین و شرایط استفاده</p>
        </div>
        <div class="desc">
        <p>
          در صورتی که از اپلیکیشن کیشوتو استفاده می کنید و با هرگونه اطلاعات، داده و یا هر ورودی دیگر (“محتوا”ی شما) که در اپلیکیشن کیشوتو  قرار می دهید، شما  در واقع دارید می پذیرید که نسبت به مفاد و شرایط (“قوانین اپلیکیشن) زیر متعهد و پایبند باشید. در صورتی که این قوانین را قبول ندارید مجاز به استفاده از خدمات این اپلیکیشن نخواهید بود. کیشوتو  قادر خواهد بود که این قوانین را در هر زمان تغییر دهد یا بروزرسانی کند. هر ویژگی جدید مانند انتشار ابزار و منابع جدید که برای بهبود و تقویت خدمات این سامانه افزوده شود مشروط به این قوانین خواهد بود. نقض هر یک از مفاد زیر ممکن است به بسته شدن حساب کاربری شما منجر شود. با وجود اینکه کیشوتو  هر گونه نقض این مفاد را کنترل و ممنوع می کند شما با استفاده از خدمات کیشوتو می پذیرید که این اپلیکیشن هیچ مسولیتی در قبال محتوای ارسال شده توسط شما ندارد و محتویات و موضوعات اپلیکیشن ها باید مطابق با قوانین جمهوری اسلامی ایران باشد.
        </p>
          <br>
          <p>
          حساب کاربری:
            <br>
          شما برای استفاده از این خدمات باید حداقل 10 سال داشته باشید. شما باید یک شخص واقعی باشید. حساب های کاربری که با روبات ها یا دیگر روش های ثبت نام خودکار در اپلیکیشن کیشوتو ثبت نام می شوند مجاز شناخته نمی شوند. مسولیت حفظ و نگهداری، محرمانه بودن و امنیت حساب کاربری شما بر عهده خود شما خواهد بود. کیشوتو هیچ مسولیتی در قبال این اطلاعات ندارد. شما مسول تمامی محتوا یا فعالیت هایی که تحت حساب کاربری شما مبادله یا انجام می شود خواهید بود( حتی زمانی که این فعالیت ها توسط افرادی به جز شخص شما انجام شود که به حساب کاربری شما دسترسی دارند). شما اجازه ندارید که این خدمات را در راستای اهداف غیر قانونی و یا غیر مجاز استفاده کنید.
          <p>
          <p>
          حریم خصوصی :
          <br>
          هرگونه اطلاعات شخصی که شما جهت استفاده از خدمات این سامانه به کیشوتو ارسال می کنید طبق مفادی که کیشوتو در قسمت حریم خصوصی توصیف کرده است نزد اپتو محفوظ خواهد بود
          </p>
          <p>
          پرداخت ها:
            <br>
          تمامی پرداخت ها از طریق کلیه کارت های عضو شتاب و در درگاه پرداخت معتبر انجام خواهد شد. هزینه خدمات غیر قابل استرداد است و به منظور رعایت مساوات هیچ استثنایی در این زمینه وجود نخواهد داشت. تمامی هزینه ها مجزا از مالیات، عوارض یا وظایف اعمال شده توسط مقامات مالیات هستند و مسولیت این موارد بر عهده شما خواهد بود. کیشوتو از لحاظ فنی تمام تلاش خود در ارائه خدمات استاندارد برای پذیرفته شدن نزد شما و جلب رضایت شما را خواهد کرد.
          </p>
          <p>
          تغییرات در خدمات و قیمت ها:
            <br>
          کیشوتو می تواند در هر زمان اقدام به تغییر و یا قطع خدمات خود به صورت موقت یا دائم کند. هزینه‌های مربوط به این خدمات نیز قابل تغییر است که در این صورت در سامانه قابل رویت خواهد بود.
          </p>
        </div>
        <button class="btn btn-outline-danger mb-3 mx-auto d-flex justify-content-center mr-2 mb-2 w-80" @click="closeRulesModal">
          بستن
        </button>
      </div>
      </transition>
    </div>

    <!--share modal-->

    <div class="container">
      <transition tag="div" name="fade">
        <div class="mandatory-modal d-flex flex-column share-modal pt-3 pb-3" v-if="sharesModal">

          <div class="qrbox d-flex flex-column align-items-center">
              <p>
                برای اشتراک گذاری کد معرف میتوانید از تصویر QRCode زیر استفاده نمایید
              </p>

            <qrcode-vue renderAs="canvas" class-name="mb-3 qrCodecanvas" :value="qrcodeUrl" size="250" level="H" />

            <a id="downloadQrCodeLink" class="btn btn-warning downloadQrCode" @click="downloadQrCode">برای دانلود تصویر کلیک کنید</a>
            <div class="mb-4 mt-3 share-link text-center">
              <span>آدرس شخصی شما:</span>
              <p>{{this.qrcodeUrl}}</p>
            </div>

          </div>
          <div class="d-flex flex-row">
            <div class="w-50 whatsapp">
              <a target="_blank" :href="`https://wa.me/?text=${shareText}`">
                <whatsapp-icon />
              </a>
            </div>

            <div class="w-50 telegram">
              <a target="_blank" :href="`https://telegram.me/share/url?url=${shareText}`">
                <telegram-icon />
              </a>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!--credit modal-->

    <div class="container">
      <transition tag="div" name="fade">
        <div class="mandatory-modal credit-amount-modal pt-5 pb-1" v-if="creditModal">

          <div class="title">
            <p>افزایـش اعــتبار</p>
          </div>

          <kish-input
              :value="credit_amount"
              v-model="credit_amount"
              :center_label="true"
              inputType="number"
              PlaceHolder="مبلغ مورد نظر به تومان"
              class="input-item credit-amount"
          />

          <div class="amount-box d-flex flex-row justify-content-around mb-2">

            <div class="amount-item" @click="credit_amount = 10000">
              <p>10,000</p>
              <span>تومان</span>
            </div>

            <div class="amount-item" @click="credit_amount = 20000">
              <p>20,000</p>
              <span>تومان</span>
            </div>

            <div class="amount-item" @click="credit_amount = 50000">
              <p>50,000</p>
              <span>تومان</span>
            </div>

          </div>
          <div class="credit-payment">
            <button class="btn pay" @click="creditPay">تایید و پرداخت</button>
          </div>

        </div>
      </transition>
    </div>


    <!--paymentinfo modal-->
    <div class="container">
        <transition tag="div" name="fade">
          <div class="mandatory-modal pt-1 pb-1" v-if="paymentinfoModal">
        <div class="title">
          <p>توضیحات خرید ها و پرداخت ها</p>
        </div>
        <div class="desc">
        <p>
          بلیط های قابل خرید درون برنامه:
          <br>

          1-خرید بلیط بازی های ساخلی
          <br>
          شما با پرداخت مبلغ شرکت در بازی های ساحلی میتوانید بلیط تمامی بازی های ساحلی را تهیه نمایید و پس خرید بلیط مشخصات خرید شما از طریق اس ام اس و ایمیل برای شما ارسال خواهد شد

          <br>
          <br>
          2- خرید بلیط فستیوال بازی های رایانه ای
          <br>
          شما با پرداخت بهای بلیط بازی های رایانه ای  میتوانید بلیط بازی مروبطه را دریافت نمایید مشخصات خرید شما از طریق اس ام اس و ایمیل برای شما ارسال خواهد شد
          <br>
          <br>
          3- خرید بلیط شرکت در مسابقه استعدادیابی موسیقی
          <br>
          شما با ثبت نام در کیشوتو میتوانید در مسابقه استعداد یابی موسیقی شرکت کردهو شانس خود را امتحان کنید مشخصات خرید شما از طریق اس ام اس و ایمیل برای شما ارسال خواهد شد
        </p>
        </div>
        <button class="btn btn-outline-danger mb-3 mx-auto d-flex justify-content-center mr-2 mb-2 w-80" @click="closePaymentinfoModal">
          بستن
        </button>
      </div>
        </transition>
    </div>



    <div class="header">

      <router-link tag="div" to="/profile/avatar" class="profile-pic" :style="{'background-image': userData.avatar === '' ? 'url(' + require('../../assets/img/profile/image.jpg') + ')' : `url(https://kishoto.ir/dtr/approid/img/${userData.avatar})`,'background-size': 'contain'}">

      </router-link>
      <h5 v-if="name">
        {{name}}
      </h5>

      <router-link tag="div" to="/" class="btn back-btn">
        بازگشت به صفحه اصلی
      </router-link>
    </div>



    <div class="top-list-profile">
      <div class="container">

        <div class="xcode-credit-main-box d-flex flex-row mb-4">

          <div class="credit-box d-flex flex-column justify-content-center align-items-center col-8" @click="OpenCreditModal">
            <div class="credit-inner-text"> میزان اعتبار شما <span>{{credit | toPersianCurrency("تومان",0)}}</span></div>
            <div class="plus-icon">
              <plus-icon></plus-icon>
            </div>
            <p class="buy-credit">افزایش اعتبار</p>
          </div>

          <div class="xcode-box d-flex flex-column justify-content-center align-items-center col-4" @click="shareModal">
            <div class="xcode-inner-text">کد معرفی شما</div>
            <div class="xcode-value">{{xcode}}</div>

            <div class="xcode-share d-flex flex-column justify-content-center">
              <account-multiple-icon></account-multiple-icon>
              <p>اشتراک گذاری</p>
            </div>
          </div>

        </div>

        <router-link to="/profile/history" class="item" tag="div">
          <star-circle-icon />
          <div class="text">
            <h6>لیست خرید‌ها شما</h6>
            <p>لیست کامل محصولاتی که شما در برنامه خریداری کرده‌اید.</p>
          </div>
        </router-link>

        <router-link to="/profile/payments" class="item" tag="div">
          <star-circle-icon />
          <div class="text">
            <h6>سوابق اعتبار شما</h6>
            <p>در این قسمت سوابق تغییر اعتبار خود را مشاهده نمایید</p>
          </div>
        </router-link>

        <div class="item">
          <phone-icon />
          <div class="text">
            <h6>
              شماره همراه شما:
              <span v-if="userData && userData.phone">{{
                userData.phone
              }}</span>
            </h6>
            <p>امکان تعویض شماره تلفن وجود ندارد.</p>
          </div>
        </div>
      </div>
    </div>

    <ProfileSetting @editUserModal="updateModalUser" @supportModal="openSupportModal" @rulesModal="openRulesModal" @paymentinfoModal="openPaymentinfoModal" />
  </div>
</template>

<script>
import ProfileSetting from "./Setting";

import StarCircleIcon from "vue-material-design-icons/StarCircle.vue";
import PlusIcon from "vue-material-design-icons/Plus.vue";
import AccountMultipleIcon from "vue-material-design-icons/AccountMultiple.vue";
import TelegramIcon from "vue-material-design-icons/Telegram.vue";
import WhatsappIcon from "vue-material-design-icons/Whatsapp.vue";

import PhoneIcon from 'vue-material-design-icons/Phone.vue';
import store from "@/store";
import QrcodeVue from 'qrcode.vue';

//import avatariamge from "~@/assets/img/profile/image.jpg";

export default {
  data() {
    return {
      new_user: false,
      isActive: false,

      name: "",
      //last_name: "",
      //nikname: "",
      userData: null,
      editUserModal:false,

      supportModal:false,
      rulesModal:false,
      paymentinfoModal:false,
      creditModal:false,
      sharesModal:false,

      supportText: "",
      modalOpened:false,

      credit:null,
      credit_amount:null,
      xcode:null,
      cardcode:null,
      otherxcode:null,

      shareText:null

      //defaultAvatar: avatariamge
    };
  },
  components: {
    ProfileSetting,
    StarCircleIcon,
    PhoneIcon,
    PlusIcon,
    AccountMultipleIcon,
    TelegramIcon,
    WhatsappIcon,
    QrcodeVue
  },
  created() {
    this.getProfile();
    this.getSupportText();
  },
  methods: {
    async getProfile() {
      let fd = new FormData();
      var encodedURL = encodeURIComponent("https://kishoto.ir");

      let mg = "سلام \n" +
          "از شما دعوت میکنم تا با نصب نرم افزار کیشوتو از جاذبه های گردشگری کیش خیلی راحت و با تخفیف های ویژه استفاده کنید \n" +
          "لطفا برای ثبت نام دیگران از کد معرف KEY استفاده شود. \n" +
          "همچنین آدرس منحصر به فرد معرف شما URL میباشد \n" +
          "دانلود نرم افزار اندرویدی کیشوتو از کافه بازار  \n" +
          "https://cafebazaar.ir/app/?id=com.nikandroid.kish_festival&ref=share";


      fd.append("token", store.state.login.loginTempToken);
      const response = await this.$ApiServiceLayer.post("get_profile", fd);

      if (response.status_code === 200){

        this.name = response.name;
        this.xcode = response.xcode;
        this.credit = response.credit;

        if(response.cardcode === "0000000000000000"){
          this.cardcode = null;
        }else{
          this.cardcode = response.cardcode;
        }

        let sharetextbefore = mg.replace("KEY", response.xcode);
        this.shareText = encodeURIComponent(sharetextbefore.replace("URL", this.qrcodeUrl));
        //this.last_name = response.family;
        //this.nikname = response.show_name;
        //this.nikname = response.show_name;

        this.userData = response;

        if (response.flag === "new_user") {
          let introduceCode = store.state.login.introduceCode;
          this.new_user = true;
          this.modalOpened = true;

          if(introduceCode != null){
            this.otherxcode = introduceCode;
            this.$store.commit("login/clearIntroducerCode");
          }

        }

      }else if(response.status_code === 500){
        this.$toast.open({
          message: 'شما نیاز به ورود مجدد به برنامه دارید',
          type: 'error',
        });
        window.localStorage.removeItem("kishoto-store");
        window.localStorage.removeItem("token");

        setTimeout(()=>{
          window.open("/","_self");
        },2000);
      }else{
        this.$toast.open({
          message: 'شما نیاز به ورود مجدد به برنامه دارید',
          type: 'error',
        });
      }
    },
    async getSupportText() {
      const response = await this.$ApiServiceLayer.post("support_text");

      if (response.status_code === 200) {

        this.supportText = response.suport_text;

      } else {
        this.$toast.open({
          message: 'مشکلی در دریافت اطلاعات پیش آمده است',
          type: 'error',
        });
      }
    },
    async updateProfile() {

      let fd = new FormData();
      fd.append("name", this.name);
      fd.append("token", store.state.login.loginTempToken);

      if(this.cardcode != null && this.otherxcode !=null ){
        console.log(this.cardcode.length);

        if(this.cardcode.length === 16) {
          fd.append("cardcode", this.cardcode);
        }else{
          fd.append("cardcode","0000000000000000");
        }

        if(this.otherxcode.length === 4){
          fd.append("xcode", this.otherxcode);
        }else{
          fd.append("xcode","0000");
        }

        /*fd.append("cardcode", this.cardcode);
        fd.append("xcode", this.xcode);*/

      }else if(this.otherxcode !=null){

        fd.append("cardcode","0000000000000000");

        console.log(this.otherxcode.length);

        if(this.otherxcode.length === 4){
          fd.append("xcode", this.otherxcode);
        }else{
          fd.append("xcode","0000");
        }

      }else if(this.cardcode != null){
        if(this.cardcode.length === 16) {
          fd.append("cardcode", this.cardcode);
        }else{
          fd.append("cardcode","0000000000000000");
        }
        fd.append("xcode","0000");
      }else{
        fd.append("cardcode","0000000000000000");
        fd.append("xcode","0000");
      }


      const response = await this.$ApiServiceLayer.post(
        "edit_profile2",
        fd
      );
      if (response.status_code === 200) {
        this.new_user = false;

        //close modal and modalbackground container
        this.closeModals();

        this.$toast.open({
          message: 'اطلاعات شما با موفقیت ذخیره شد',
          type: 'success',
          // all of other options may go here
        });
        this.getProfile();
      }
    },

    //user data modal
    updateModalUser(newvalue){
      this.editUserModal = newvalue;
      this.modalOpened = true;
    },
    closeEditUserModal(){
      this.editUserModal = false;
      this.modalOpened = false;
    },

    //support modal
    openSupportModal(newvalue){
      this.supportModal = newvalue;
      this.modalOpened = true;
    },

    closeSupportModal(){
      this.supportModal = false;
      this.modalOpened = false;
    },

    //payment info modal

    openPaymentinfoModal(newvalue){
      this.paymentinfoModal = newvalue;
      this.modalOpened = true;
    },

    closePaymentinfoModal(){
      this.paymentinfoModal = false;
      this.modalOpened = false;
    },

    //rules modal

    openRulesModal(newvalue){
      this.rulesModal = newvalue;
      this.modalOpened = true;
    },

    closeRulesModal(){
      this.rulesModal = false;
      this.modalOpened = false;
    },

    //share modal

    shareModal(){
      this.sharesModal = true;
      this.modalOpened = true;
    },


    //close globalmodal
    closeModals(){

      if(this.new_user === false){
        this.supportModal = false;
        this.editUserModal = false;
        this.rulesModal = false;
        this.paymentinfoModal = false;
        this.modalOpened = false;
        this.sharesModal = false;
        this.creditModal = false;
      }

    },
    OpenCreditModal(){
      this.creditModal = true;
      this.modalOpened = true;
    },
    async creditPay(){
      this.$toast.open({
        message: 'لطفا تا ورود به درگاه منتظر باشید',
        type: 'info',
      });

      let fd = new FormData();
      fd.append("amount", this.credit_amount);
      fd.append("token", store.state.login.loginTempToken);

      const response = await this.$ApiServiceLayer.post("add_credit", fd);
      console.log(response);

      if (response.status_code === 200) {
          this.$toast.clear();
          this.$toast.open({
            message: 'به درگاه بانک منتقل میشوید',
            type: 'success',
          });

          this.loading = false;

          setTimeout(()=>{
            window.open(response.pay_url,'_self');
          },1000);
          console.log(response);

      }
    },
    downloadQrCode(){
      var download = document.getElementById("downloadQrCodeLink");
      var image = document.querySelector(".qrCodecanvas canvas").toDataURL("image/png")
          .replace("image/png", "image/octet-stream");
      download.download = 'downloadQrCode.png';
      download.setAttribute("href", image);
    }

  },
  computed:{
    qrcodeUrl(){
      return "https://kishoto.ir/introduce/"+this.xcode;
    }
  }
};
</script>

<style scoped lang="scss">
.profile-module {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  position: relative;
  .support-modal{
    height: 500px !important;
  }

  .mandatory-modal {
    position: fixed;
    height: auto;
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0px;
    direction: rtl;
    z-index: 2;
    overflow-y:scroll;
    overflow-x:hidden;
    border: 1px dashed #80808033;
    .title {
      width: 100%;
      height: 3px;
      background-color: blue;
      margin-top: 40px;
      text-align: left;
      position: relative;
      p {
        position: absolute;
        padding: 10px 20px;
        background-color: rgb(255, 255, 255);
        font-family: "sansb";
        top: -20px;
        right: 5%;
      }
    }
    .desc {
      width: 100%;
      padding: 0 20px;
      text-align: right;
      margin-top: 20px;
      p {
        font-family: "sans";
        font-size: 14px;
        line-height: 28px;
      }
    }
  }

  .share-modal{
    height: auto;
    width: 90%;
    overflow: hidden;
    padding: 23px;
    a{
      span{
        width: 100%;
        height: 100%;
        justify-content: center;
        svg{
          font-size: 33px;
        }
      }
    }

    .whatsapp{
      span{
        svg{
          color:#00e676;
          width: 51px;
          height: 51px;
        }
      }
    }
    .telegram{
      span{
        svg{
          color: #ffff;
          background: #0088CC;
          border-radius: 50%;
          padding: 5px 4px 4px 2px;
          width: 51px;
          height: 51px;
        }
      }
    }
    .share-link{
      span{

      }
      p{
        font-size: 16px;
        font-weight: bold;
        color: #210101;
      }
    }
  }

  .credit-amount-modal{
      width: 94%;
      height: auto;
      border: 4px dashed blue;
    .title {
      width: 94%;
      height: 1px;
      background-color: blue;
      margin-top: 40px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;

      p {
        position: initial;
        padding: 10px 20px;
        background-color: rgb(255, 255, 255);
        font-family: "sansb";
        font-size: 16px;
      }
    }
    .credit-amount{
      width: 89% !important;
      margin: 0 auto;
      margin-bottom: 26px;
      .input-container {
        label {
          right: 0 !important;
          left: 0 !important;
        }
      }
    }
    .amount-box{

      .amount-item{
        padding: 10px 30px;
        background: #536DFE;
        color: #ffff;
        border-radius: 8px;
        text-align: center;
        p{
          font-size: 22px;
          margin-bottom: 4px;
        }
      }

    }
    .credit-payment{
      padding: 7px;
      .pay{
        padding: 12px 48px;
        background: #536DFE;
        color: #ffff;
        border-radius: 8px;
        width: 100%;
        font-size: 20px;
        margin-top: 18px;
      }
    }
  }

  .input-item {
    margin-bottom: 40px;
  }

  .save-data {
    width: 100%;
    height: 50px;
    background-color: rgb(7, 161, 7);
    color: #fff;
    font-family: "sansb";
  }

  .header {
    width: 100%;
    height: 200px;
    background-image: url("~@/assets/img/main/profile_header.jpg");
    background-position: center;
    background-size: cover;
    box-shadow: 0px 0px 6px gray;
    position: relative;
    .profile-pic {
      position: absolute;
      top: 70%;
      left: 50%;
      transform: translateX(-50%);
      width: 120px;
      height: 120px;
      border-radius: 50%;
      border: 3px solid #000;
      background-color: #fff;
    }
     h5 {
      position: absolute;
      top: 134%;
      left: 50%;
      transform: translateX(-50%);
      font-family: "sansb";
      font-size: 19px;
    }
    .back-btn{
      background: #ffffff;
      padding: 10px;
      box-shadow: 3px 5px 17px #80808091;
      border-radius: 5px;
      position: absolute;
      top: 149%;
      left: 51%;
      transform: translateX(-50%);
      font-family: "sansb";
      font-size: 15px;
    }
  }

  .top-list-profile {
    width: 100%;
    height: auto;
    margin-top: 154px;
    text-align: right;
    direction: rtl;
    .xcode-credit-main-box{
      .credit-box{
        padding: 20px;
        border: 2px dashed #536dfe;
        margin-left: 6px;
        border-radius: 20px;
        .plus-icon,.buy-credit{
          color:#536dfe;
        }
        .credit-inner-text {
          font-size: 15px;
          span{
            font-size: 19px;
            font-weight: bold;
          }
        }
        .plus-icon{
          margin: 7px 0 9px;
          span:first-child{
            width: 100%;
            height: 100%;
            justify-content: center;
            svg{
              font-size: 31px;
              font-weight: bold;
            }
          }
        }
        .buy-credit{
          font-size: 17px;
          margin-bottom: 0;
          margin-top: 16px;
        }
      }
      .xcode-box{
        padding: 8px;
        border: 2px dashed #4caf50;
        border-radius: 20px;
        padding-top: 19px;
        .xcode-share{
          color:#4caf50;
          height: 100%;
          span{
            width: 100%;
            height: 100%;
            justify-content: center;
            svg{
              font-size: 32px;
            }
          }
          p{
            margin-top: 5px;
          }
        }
        .xcode-value{
          font-size: 20px;
          font-weight: bold;
          margin: 13px 0 36px;
        }
      }
    }
    .item {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-bottom: 30px;
      .text {
        margin-right: 10px;
        p {
          font-family: "sans";
          font-size: 12px;
          margin-bottom: 0;
          color: #757575;
        }
        h6 {
          font-family: "sansb";
          font-size: 15px;
        }
      }



      span.material-design-icon{
          margin-left: 8px;
            svg {
              color: #2640d6;
              font-size: 24px;
            }
        }


    }
  }
  .pre-formatted {
    white-space: pre;
  }

  .madalbackground{
    width: 100%;
    height: inherit;
    background: #0000006e;
    position: fixed;
    z-index: 1;
  }
}
</style>
